<template>
    <div id="index">
        <el-scrollbar :class="isCollapse?'menu_hide rightSide':'rightSide'">
            <el-main>
                <!--                <el-breadcrumb separator-class="el-icon-arrow-right" class="mainBread">-->
                <!--                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>-->
                <!--                    <el-breadcrumb-item :to="{ path: '/' }">{{$t('RealTimeMonitoring')}}</el-breadcrumb-item>-->
                <!--                    <el-breadcrumb-item>Web端专屏</el-breadcrumb-item>-->
                <!--                </el-breadcrumb>-->
                <nav-bar></nav-bar>
                <template>
                    <el-tabs v-model="activeTab" @tab-click="handleClick">
                        <el-tab-pane name="first">
                            <span slot="label"><i class="el-icon-monitor"></i> {{ $t('Alarm') }}<small
                                    class="stateBell">{{notifcount}}</small></span>
                            <el-form ref="formselect" :model="formselect" label-width="80px" class="queryform_div">
                                <areaSelect :level="level" :deviceType="deviceType" :formArea="formArea"
                                            :enablesys="'1'"
                                            @areaList="getAreaList"></areaSelect>
                                <el-form-item>
                                    <el-button @click="GetLabNoitif"  type="primary">{{ $t('Query') }}</el-button>
                                    <el-button @click="reset">{{ $t('Reset') }}</el-button>
                                </el-form-item>
                            </el-form>
                            <div class="siteDiv" v-for="item in LabListv1"  :key="item.id">
                                <h3>{{item.factoryName}}</h3>
                                <div class="buildingDiv"  v-for="item1 in item.buildlist"  :key="item1.buildingId">
                                    <h5>{{item1.buildingName}}</h5>
                                    <el-row :gutter="24" class="LabThumbnail">
                                        <el-col :xs="24" :sm="12" :md="8" :lg="6"
                                         v-for="item2 in item1.lablist"
                                        :key="item2.id"
                                        >
                                            <a class="grid-content bg-purple-light">
                                                <div class="LabInfo" @click="toLabInfo(item2.labId)">
                                                    <el-row :gutter="24">
                                                        <el-col :span="8">
                                                            <span v-if="item2.powerAlarmLevel=='Level1'" class="state"
                                                                :style="{'backgroundImage': 'url(' + imgurl12  + ')'}"></span>
                                                            <span v-else-if="item2.powerAlarmLevel=='Level2'" class="state"
                                                                :style="{'backgroundImage': 'url(' + imgurl13  + ')'}"></span>
                                                            <span v-else class="state"
                                                                :style="{'backgroundImage': 'url(' + imgurl11  + ')'}"></span>
                                                            <h5>{{ $t('ElectricalSafety') }}</h5>
                                                        </el-col>
                                                        <el-col :span="8">
                                                            <span class="state"
                                                                :style="{'backgroundImage': 'url(' + imgurl21  + ')'}"></span>
                                                            <h5>{{ $t('ElectricalLoad') }}</h5>
                                                        </el-col>
                                                        <el-col :span="8">
                                                            <span v-if="item2.environmentAlarmLevel=='Level1'"
                                                                class="state"
                                                                 :style="{'backgroundImage': 'url(' + imgurl32  + ')'}"></span>
                                                            <span v-else-if="item2.environmentAlarmLevel=='Level2'"
                                                                class="state" :style="{'backgroundImage': 'url(' + imgurl33  + ')'}"></span>
                                                             <span v-else class="state"
                                                                :style="{'backgroundImage': 'url(' + imgurl31  + ')'}"></span>
                                                            <h5>{{ $t('EnvironmentalSafety') }}</h5>
                                                        </el-col>
                                                    </el-row>
                                                </div>
                                                <span>{{item2.labName}}</span>
                                            </a>
                                        </el-col>
                                    </el-row>
                                </div>
                            </div>


                        </el-tab-pane>
                        <el-tab-pane name="second">
                            <span slot="label"><i class="el-icon-monitor"></i> {{ $t('All') }}</span>

                            <el-form ref="formselect" :model="formselect" label-width="80px" class="queryform_div">
                                <areaSelect :level="level" :deviceType="deviceType" :formArea="formArea"
                                            :enablesys="'1'"
                                            @areaList="getAreaList"></areaSelect>
                                <el-form-item>
                                    <el-button @click="GetLabNoitif"  type="primary">{{ $t('Query') }}</el-button>
                                    <el-button @click="reset">{{ $t('Reset') }}</el-button>
                                </el-form-item>
                            </el-form>

                            <div class="siteDiv" v-for="item in LabListv2"  :key="item.id">
                                <h3>{{item.factoryName}}</h3>
                                <div class="buildingDiv"  v-for="item1 in item.buildlist"  :key="item1.buildingId">
                                    <h5>{{item1.buildingName}}</h5>
                                    <el-row :gutter="24" class="LabThumbnail">
                                        <el-col :xs="24" :sm="12" :md="8" :lg="6"
                                         v-for="item2 in item1.lablist"
                                        :key="item2.id"
                                        >
                                            <a class="grid-content bg-purple-light">
                                                <div class="LabInfo" @click="toLabInfo(item2.labId)">
                                                    <el-row :gutter="24">
                                                        <el-col :span="8">
                                                            <span v-if="item2.powerAlarmLevel=='Level1'" class="state"
                                                                :style="{'backgroundImage': 'url(' + imgurl12  + ')'}"></span>
                                                            <span v-else-if="item2.powerAlarmLevel=='Level2'" class="state"
                                                                :style="{'backgroundImage': 'url(' + imgurl13  + ')'}"></span>
                                                            <span v-else class="state"
                                                                :style="{'backgroundImage': 'url(' + imgurl11  + ')'}"></span>
                                                            <h5>{{ $t('ElectricalSafety') }}</h5>
                                                        </el-col>
                                                        <el-col :span="8">
                                                            <span class="state"
                                                                :style="{'backgroundImage': 'url(' + imgurl21  + ')'}"></span>
                                                            <h5>{{ $t('ElectricalLoad') }}</h5>
                                                        </el-col>
                                                        <el-col :span="8">
                                                            <span v-if="item2.environmentAlarmLevel=='Level1'"
                                                                class="state"
                                                                :style="{'backgroundImage': 'url(' + imgurl32  + ')'}"></span>
                                                            <span v-else-if="item2.environmentAlarmLevel=='Level2'"
                                                                class="state"
                                                                :style="{'backgroundImage': 'url(' + imgurl33  + ')'}"></span>
                                                             <span v-else class="state"
                                                                :style="{'backgroundImage': 'url(' + imgurl31  + ')'}"></span>
                                                            <h5>{{ $t('EnvironmentalSafety') }}</h5>
                                                        </el-col>
                                                    </el-row>
                                                </div>
                                                <span>{{item2.labName}}</span>
                                            </a>
                                        </el-col>
                                    </el-row>
                                </div>

                            </div>


                            <!-- <el-row :gutter="24" class="LabThumbnail">
                                <el-col :xs="24" :sm="12" :md="8" :lg="6"
                                        v-for="item in LabList1"
                                        :key="item.id">
                                    <a class="grid-content bg-purple-light">
                                        <div class="LabInfo" @click="toLabInfo(item.id)">
                                            <el-row :gutter="24">
                                                <el-col :span="8">
                                                    <span v-if="item.powerAlarmLevel=='Level1'"
                                                          class="state"
                                                          :style="{'backgroundImage': 'url(' + imgurl12  + ')'}"></span>
                                                    <span v-else-if="item.powerAlarmLevel=='Level2'"
                                                          class="state"
                                                          :style="{'backgroundImage': 'url(' + imgurl13  + ')'}"></span>
                                                    <span v-else class="state"
                                                          :style="{'backgroundImage': 'url(' + imgurl11  + ')'}"></span>
                                                    <h5>用电安全</h5>
                                                </el-col>
                                                <el-col :span="8">
                                                    <span class="state"
                                                          :style="{'background-image': 'url(' + imgurl21  + ')'}"></span>
                                                    <h5>电力负载</h5>
                                                </el-col>
                                                <el-col :span="8">
                                                    <span v-if="item.environmentAlarmLevel=='Level1'"
                                                          class="state"
                                                          :style="{'backgroundImage': 'url(' + imgurl12  + ')'}"></span>
                                                    <span v-else-if="item.environmentAlarmLevel=='Level2'"
                                                          class="state"
                                                          :style="{'backgroundImage': 'url(' + imgurl13  + ')'}"></span>
                                                    <span v-else class="state"
                                                          :style="{'backgroundImage': 'url(' + imgurl11  + ')'}"></span>
                                                    <h5>环境安全</h5>
                                                </el-col>
                                            </el-row>
                                        </div>
                                        <span>{{item.labName}}</span>
                                    </a>
                                </el-col>
                            </el-row> -->
                        </el-tab-pane>
                    </el-tabs>
                </template>
            </el-main>
        </el-scrollbar>
    </div>
</template>

<script>
import n_green1 from "../../assets/img/TopState1G.png";
import n_yellow1 from "../../assets/img/TopState1Y.png";
import n_red1 from "../../assets/img/TopState1R.png";
import n_green2 from "../../assets/img/TopState2G.png";
import n_yellow2 from "../../assets/img/TopState2Y.png";
import n_red2 from "../../assets/img/TopState2R.png";
import n_green3 from "../../assets/img/TopState3G.png";
import n_yellow3 from "../../assets/img/TopState3Y.png";
import n_red3 from "../../assets/img/TopState3R.png";
import areaSelect from "../../components/content/maintabber/areaSelect";
import { mapState } from "vuex";
import { GetAllLabNoitif, GetAllLabInfoList } from "../../api/api";
import { setCookie, getCookie } from "../../../utils/package-cookies";
export default {
  name: "index",
  components: {
    areaSelect,
  },
  computed: mapState({
    isCollapse: (state) => state.isCollapse,
  }),
  data() {
    return {
      level: 4,
      deviceType: "",
      formArea: {
        cityId: "",
        factoryId: "",
        buildingId: "",
        LabId: "",
        deviceId: "",
      },

      formselect: {},
      activeTab: "first",
      LabList: [],
      LabListv1: [],
      LabList1: [],
      LabListv2:[],
      imgurl11: n_green1,
      imgurl12: n_yellow1,
      imgurl13: n_red1,
      imgurl21: n_green2,
      imgurl22: n_yellow2,
      imgurl23: n_red2,
      imgurl31: n_green3,
      imgurl32: n_yellow3,
      imgurl33: n_red3,
      notifcount: 0,
    };
  },
  mounted() {
    this.GetLabNoitif();
    // this.GetLabInfoList()
    //this.notifcount = sessionStorage.getItem('notifcount');
    if (this.notifcount == "0") {
      this.notifcount = "";
    }
    let ac = getCookie("labActive");
    if (ac) {
      this.activeTab = ac;
    }
  },
  methods: {
    reset() {
      this.formArea = {
        cityId: "",
        factoryId: "",
        buildingId: "",
        LabId: "",
        deviceId: "",
      };
      this.formselect = { deviceId: "", deviceCode: "" };
      this.GetLabNoitif();
    },
    getAreaList(e) {

      this.formselect = { ...this.formselect, ...e.Valueform };
    },
    GetLabNoitif() {
         
      this.formArea = Object.assign(this.formArea, this.formselect);
      let data = GetAllLabNoitif(this.formArea).then((res) => {
        if (res.success) {
             
          this.LabList = res.result;
          this.notifcount = this.LabList.length;
          this.DataGroup(this.LabList,"alarm");
          this.GetLabInfoList(this.formArea);
        }
      });
    },
    GetLabInfoList(e) {
      let data = GetAllLabInfoList(e).then((res) => {
        if (res.success) {
          this.LabList1 = res.result;
          this.DataGroup(this.LabList1,"all");


          for (let i = 0; i < this.LabList.length; i++) {
            for (let k = 0; k < this.LabListv2.length; k++) {
                for(let j =0;j<this.LabListv2.length;j++){
                    for(let m=0; m<this.LabListv2[j].buildlist.length;m++){
                         for(let m=0; m<this.LabListv2[j].buildlist.length;m++){
                              for(let n=0; n<this.LabListv2[j].buildlist[m].lablist.length;n++){
                                if (this.LabList[i].labId == this.LabListv2[j].buildlist[m].lablist[n].labId) {
                                    this.LabListv2[j].buildlist[m].lablist.splice(n, 1);
                                    let newlab = {
                                    labId: this.LabList[i].labId,
                                    labName: this.LabList[i].labName,
                                    powerAlarmLevel: this.LabList[i].powerAlarmLevel,
                                    powerLoadAlarmLevel: this.LabList[i].powerLoadAlarmLevel,
                                    environmentAlarmLevel: this.LabList[i].environmentAlarmLevel,
                                    };
                                    this.LabListv2[j].buildlist[m].lablist.splice(n, 0, newlab);

                                }
                            }
                        }
                }

              }
            }
          }
        }
      });
    },
    //数据分组-buildId
    DataGroup(arr,alarmType){
        var map = {},
        buildlist = [];
        for(var i = 0; i < arr.length; i++){
            var ai = arr[i];
            if(!map[ai.buildingId]){
                buildlist.push({
                    buildingId: ai.buildingId,
                    buildingCode: ai.buildingCode,
                    buildingName: ai.buildingName,
                    factoryId:ai.factoryId,
                    factoryCode:ai.factoryId,
                    factoryName:ai.factoryName,
                    lablist: [ai]
                });
                map[ai.buildingId] = ai;
            }else{
                for(var j = 0; j < buildlist.length; j++){
                    var dj = buildlist[j];
                    if(dj.buildingId == ai.buildingId){
                        dj.lablist.push(ai);
                        break;
                    }
                }
            }
        }
        this.DataGroup1(buildlist,alarmType)

    },
    //数据分组-factoryId
    DataGroup1(arr,alarmType){
        var map = {},
        factorylist = [];
        for(var i = 0; i < arr.length; i++){
            var ai = arr[i];
            if(!map[ai.factoryId]){
                factorylist.push({
                    factoryId:ai.factoryId,
                    factoryCode:ai.factoryId,
                    factoryName:ai.factoryName,
                    buildlist: [ai]
                });
                map[ai.factoryId] = ai;
            }else{
                for(var j = 0; j < factorylist.length; j++){
                    var dj = factorylist[j];
                    if(dj.factoryId == ai.factoryId){
                        dj.buildlist.push(ai);
                        break;
                    }
                }
            }
        }
         
        if(alarmType =='all'){
            this.LabListv2 = factorylist;
        }
        if(alarmType =='alarm'){
            this.LabListv1  = factorylist;
        }


    },

    toLabInfo(labId) {
      // let routerUrl = this.$router.resolve({
      //     name: "/web_screen",
      //     params: {
      //         value: labId
      //     }
      // })
      // window.open(routerUrl.href,'_blank')
      this.$router.push({
        name: "/web_screen",
        params: {
          value: labId,
        },
      });
    },
    //选项卡切换，分页重置
    handleClick() {
      //tab,event
      setCookie("labActive", this.activeTab);
    },
  },
};
</script>

<style scoped>
.LabInfo [class*=el-col-] {
    padding-left: 1px !important;
    padding-right: 4px !important;
}
.el-tabs--border-card {
  box-shadow: none;
}

.el-tabs__item {
  padding: 0 10px;
}

.el-tabs__item span {
  padding: 0 10px;
}

.stateBell {
  background-color: #f56c6c;
  border-radius: 10px;
  color: #fff;
  display: inline-block;
  font-size: 12px;
  height: 18px;
  width: 18px;
  line-height: 18px;
  text-align: center;
  white-space: nowrap;
  border: 1px solid #fff;
  margin-left: 5px;
}
</style>
